module.exports = __webpack_public_path__ + "img/poker-bg.38e99369.png";